export type TLlmFeedbackRating = 'like' | 'dislike';

export type TLlmFeedbackContentType =
  | 'job-technical'
  | 'job-non-technical'
  | 'vuln-technical-details'
  | 'vuln-remediation'
  | 'business-impact'
  | 'technical-impact';

export const FEEDBACK_TYPE = {
  JOB_TECHNICAL: 'job-technical',
  JOB_NON_TECHNICAL: 'job-non-technical',
  VULN_TECHNICAL_DETAILS: 'vuln-technical-details',
  VULN_REMEDIATION: 'vuln-remediation',
  VULN_BUSINESS_IMPACT: 'business-impact',
  VULN_TECHNICAL_IMPACT: 'technical-impact',
} as const satisfies Record<string, TLlmFeedbackContentType>;

export type TSubmitLlmRatingPayload = {
  contentType: TLlmFeedbackContentType;
  contentId: string;
  rating: TLlmFeedbackRating;
};

export type TSubmitLlmCommentPayload = {
  contentType: TLlmFeedbackContentType;
  contentId: string;
  comment: string;
};
